import { environment } from '../../../environments/environment';
import { CrazyCallConfigService } from './services/crazycall-config.service';
import * as i0 from "@angular/core";
import * as i1 from "./services/crazycall-config.service";
var LeadGenerationCodeService = /** @class */ (function () {
    function LeadGenerationCodeService(crazyCallConfigService) {
        this.crazyCallConfigService = crazyCallConfigService;
    }
    LeadGenerationCodeService.prototype.htmlCodeToInstall = function () {
        // noinspection CheckTagEmptyBody,JSUnresolvedLibraryURL
        return "<script>\n  window.ChannelsSettings = {\n    appId: \"" + this.crazyCallConfigService.appId + "\"\n  };\n</script>\n<script defer src=\"" + environment.WEB_CALL_SCRIPT_URL + "\"></script>\n    ";
    };
    LeadGenerationCodeService.ngInjectableDef = i0.defineInjectable({ factory: function LeadGenerationCodeService_Factory() { return new LeadGenerationCodeService(i0.inject(i1.CrazyCallConfigService)); }, token: LeadGenerationCodeService, providedIn: "root" });
    return LeadGenerationCodeService;
}());
export { LeadGenerationCodeService };
